import { CardActionTypes } from "../../../action-types";

export const setActiveCard = (activeCard) => {
  localStorage.setItem("activeCard", JSON.stringify(activeCard));
  return {
    type: CardActionTypes.SET_ACTIVE_CARD,
    payload: activeCard,
  };
};

export const setClientCards = (clientCards) => {
  localStorage.setItem("clientCards", JSON.stringify(clientCards));
  return {
    type: CardActionTypes.FETCH_CLIENT_CARDS,
    payload: clientCards,
  };
}
